import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { bool } from "prop-types";
import { toastr } from "react-redux-toastr";
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock
} from "react-bootstrap";
import { create } from "../../utils/apiService";

class SMSSending extends Component {
  constructor() {
    super();

    this.state = {
      value: "",
      count: 0,
      disabled: false
    };

    this.getValidationState = this.getValidationState.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  getValidationState() {
    const value = this.state.value;
    const length = value.length;
    if (length > 135) return "error";
    else if (length === 0) return null;
    else if (!/\*\|URL\|\*/g.test(value)) return "error";
    else if (/\*\|URL\|\*/.test(value)) return "success";
    return null;
  }
  handleChange(e) {
    let value = e.target.value;
    this.setState({ value, count: value.length });
  }
  componentWillUnmount() {
    this.setState({ count: 0, value: "" });
  }
  sendSMS() {
    if (this.getValidationState() !== "success") {
      toastr.error(
        "O texto deve ser menor que 135 caracteres e conter *|URL|*"
      );
      return;
    }
    this.setState({ disabled: true });
    toastr.info("Enviando SMS");
    const { video, sendingId } = this.props;
    let url = `/campaigns/${video.campaign_id}/videos/${
      video.id
    }/sendings/${sendingId}/sms`;
    create(url, {
      text: this.state.value
    })
      .then(res => {
        toastr.success("SMS enviado com sucesso!");
        this.setState({ count: 0, value: "", disabled: false });
        console.log(res);
      })
      .catch(err => {
        toastr.error("Ocorreu um erro ao enviar o SMS");
        this.setState({ disabled: false });
      });
  }
  render() {
    const { show } = this.props;
    let { count } = this.state;
    return (
      <Modal show={show}>
        <Modal.Header>Envio de SMS</Modal.Header>
        <Modal.Body>
          <FormGroup
            controlId="formBasicText"
            validationState={this.getValidationState()}
          >
            <ControlLabel>Digite o texto desejado.</ControlLabel>
            <FormControl
              componentClass="textarea"
              value={this.state.value}
              placeholder="Digite o SMS desejado"
              onChange={this.handleChange}
            />
            <FormControl.Feedback />
            <HelpBlock>
              Contador: {count}. Verifique se a tag *|URL|* está sendo utilizada
            </HelpBlock>
          </FormGroup>
        </Modal.Body>

        <Modal.Footer>
          <button
            className="btn btn-link"
            onClick={() => {
              this.setState({ count: 0, value: "", disabled: false });
              this.props.close();
            }}
          >
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            disabled={this.state.disabled}
            onClick={() => {
              this.sendSMS();
            }}
          >
            Enviar
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SMSSending.propTypes = {
  show: bool
};

export default SMSSending;



// WEBPACK FOOTER //
// ./src/components/modals/SMSSendingModal.js